










































import { Component, Prop, ProvideReactive, Vue } from 'vue-property-decorator'
import GeofenceMessage from '@/_interfaces/GeofenceMessage'
import MessageItem from '@/components/geofence_monitor/partials/MessageItem.vue'
import MobileMessageLayout from './partials/MobileMessageLayout.vue'
@Component({
  components: {
    MessageItem,
    MobileMessageLayout,
  },
})
export default class MonitorMessage extends Vue {
  @Prop() messages!: GeofenceMessage[]
  @Prop({ default: false }) isShowClose!: boolean
  @Prop({ default: '' }) classCustomes!: string

  showPanel: boolean = true
  searchQuery: string = ''

  @ProvideReactive('message-monitor')
  get filteredData() {
    if (!this.messages) {
      return []
    }

    return this.messages.filter((message) => {
      const searchByUName = message.u_name.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0
      const searchByLocation = message.geo_name.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0

      return searchByUName || searchByLocation
    })
  }
}
